const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000

export interface GrowthWindow {
  key: string
  label: string
  start: Date
  end: Date
  partial: boolean
}

export interface GrowthMonth {
  key: string
  label: string
  profiles: number
  applications: number
  partial: boolean
}

function storedTime(value: unknown): number | null {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.getTime()
  if (typeof value === 'object' && value !== null && typeof (value as { toDate?: () => Date }).toDate === 'function') {
    return storedTime((value as { toDate: () => Date }).toDate())
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const time = new Date(value).getTime()
    return Number.isNaN(time) ? null : time
  }
  return null
}

export function nonAdminProfileCounts(
  profiles: Array<{ isAdmin?: boolean; createdAt?: unknown }>,
  windows: GrowthWindow[],
): number[] {
  return windows.map(window => profiles.filter(profile => {
    if (profile.isAdmin === true) return false
    const time = storedTime(profile.createdAt)
    return time !== null && time >= window.start.getTime() && time < window.end.getTime()
  }).length)
}

// Six calendar months including the current, partial month. Boundaries are
// midnight IST expressed in UTC; India has no daylight-saving transition.
export function growthWindows(now: Date, months = 6): GrowthWindow[] {
  const ist = new Date(now.getTime() + IST_OFFSET_MS)
  const year = ist.getUTCFullYear()
  const month = ist.getUTCMonth()
  return Array.from({ length: months }, (_, index) => {
    const offset = index - months + 1
    const first = new Date(Date.UTC(year, month + offset, 1))
    const last = new Date(Date.UTC(year, month + offset + 1, 1))
    const start = new Date(first.getTime() - IST_OFFSET_MS)
    const nextStart = new Date(last.getTime() - IST_OFFSET_MS)
    const partial = offset === 0
    return {
      key: `${first.getUTCFullYear()}-${String(first.getUTCMonth() + 1).padStart(2, '0')}`,
      label: new Intl.DateTimeFormat('en-IN', { month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' }).format(start),
      start,
      end: partial ? now : nextStart,
      partial,
    }
  })
}
